import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Samantha/subs.vtt';
import poster from '@/static/assets/reviews/Samantha/video.jpg';

export const Samantha: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Samantha',
  videoUrl: `${ASSETS_URL}/car/Samantha.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
